/** Mantine represents wall time as a string; the API continues to receive epoch milliseconds. */
export function toLocalDateTime(epoch: number | null | undefined): string | null {
  if (epoch == null || !Number.isFinite(epoch)) return null;
  const date = new Date(epoch);
  if (Number.isNaN(date.getTime())) return null;
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function fromLocalDateTime(value: string | null): number | undefined {
  if (!value) return undefined;
  if (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) return undefined;
  const epoch = new Date(value.replace(" ", "T")).getTime();
  // Reject invalid dates and DST gaps rather than silently moving the appointment.
  return Number.isFinite(epoch) && toLocalDateTime(epoch) === value ? epoch : undefined;
}
